import { routeStoreLenses } from 'root/src/client/logic/route/lenses'
import { SET_PREVIOUS_ROUTE } from 'root/src/client/logic/route/actionIds'

const { setPreviousRoute } = routeStoreLenses

export default {
	[SET_PREVIOUS_ROUTE]: (state, payload) => setPreviousRoute(payload, state),
}
